module.exports = __webpack_public_path__ + "img/facility_search.bc80f8a3.png";